import { createContext, Dispatch, SetStateAction, useContext } from "react";
import { ActiveCity } from "providers/LocationProvider";

type ContextProps = {
    onChangeCity: Dispatch<SetStateAction<ActiveCity | null>>;
    onChangeTimezone: Dispatch<SetStateAction<string>>;
};

export const LocationApiContext = createContext<ContextProps>({
    onChangeCity: () => {},
    onChangeTimezone: () => {},
});

export const useLocationApiContext = () => useContext(LocationApiContext);
